import { useMemo } from "react";
import { Column } from "react-table";
import {
  GridView,
  DefaultColumnFilter,
  SelectColumnFilter,
} from "@funcional/react-table-ui";
import { Title } from "@funcional/react-ui";
import { IntlDateTime } from "@funcional/react-intl-ui";
import { useI18n } from "@common/helpers";
import { IRefundProgram } from "../contracts";
import { useRefundPrograms } from "../hooks";

export default function ViewRefundProgram() {
  const { intlEnum } = useI18n();

  function editRecord() {
    alert("Essa funcionalidade ainda está sendo construída");
  }

  const columns: Column<IRefundProgram>[] = useMemo(
    () => [
      {
        Header: "Programa",
        accessor: "program",
        Filter: DefaultColumnFilter,
        Cell: ({ value }) => value,
      },
      {
        Header: "Rede",
        accessor: "headquarter",
        Filter: DefaultColumnFilter,
      },
      {
        Header: "Tipo de reposição",
        accessor: "refundType",
        Cell: ({ value }) => (
          <div
            style={{
              borderRadius: "8px",
              backgroundColor: value === "direta" ? "#dcf1d4" : "#e8ecd2",
            }}
          >
            {value === "direta"
              ? `Financeira (${value})`
              : `Estoque (${value})`}
          </div>
        ),
        Filter: SelectColumnFilter,
        options: [
          { value: "direta", description: "Financeira (direta)" },
          { value: "indireta", description: "Estoque (indireta)" },
        ],
      },
      {
        Header: "Início da vigência",
        accessor: "startDate",
        Cell: ({ value }) => (value ? <IntlDateTime value={value} /> : "-"),
      },
      {
        Header: "Fim da vigência",
        accessor: "endDate",
        Cell: ({ value }) => (value ? <IntlDateTime value={value} /> : "-"),
      },
    ],
    [intlEnum]
  );
  return (
    <>
      <div className="flex w-full items-center mb-4">
        <div className="flex-1">
          <Title marginBottom={0}>Programas de Reposição</Title>
        </div>
      </div>
      <hr className="mb-2" />

      <GridView<IRefundProgram>
        accessControlResourceName="refundPrograms"
        paginationType="cursor"
        paginas
        paginated
        columns={columns}
        hook={useRefundPrograms}
        editRecord={editRecord}
      />
    </>
  );
}
